import { Redirect, Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import IntegrationsPage from './Integrations/IntegrationsPage';
import AccountingSoftware from './AccountingSoftware/AccountingSoftware';
import AccountingSoftwarePage from './AccountingSoftware/AccountingSoftwarePage';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { JSX } from 'react';

// Flinks, Plaid, Inverite and Global Payments are configured from the marketplace's setup drawer now;
// their former pages are gone, so any old link or bookmark lands back on the catalogue
const RETIRED_INTEGRATION_ROUTES = [
  '/integrations/Flinks',
  '/integrations/Flinks/Update',
  '/integrations/Plaid',
  '/integrations/Plaid/Update',
  '/integrations/Inverite',
  '/integrations/Inverite/Update',
  '/integrations/global-pay',
];

export default function Routes(): JSX.Element {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('integrations');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations"
        component={IntegrationsPage}
      />

      {RETIRED_INTEGRATION_ROUTES.map((path) => (
        <Redirect key={path} exact from={path} to="/integrations" />
      ))}

      {/* Current (Railz) accounting connection flow */}

      <ProtectedRoute
        path="/integrations/accounting-software"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftware isSettings />
      </ProtectedRoute>

      <ProtectedRoute
        exact
        path="/integrations/accounting-software/connect"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftware isSettings />
      </ProtectedRoute>

      {/* New (ASP) connection & GL setup — orphan pages, reachable by URL only (ID-13335) */}
      <ProtectedRoute
        exact
        path="/accounting/integrations/accounting-software"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftwarePage />
      </ProtectedRoute>

      <ProtectedRoute
        exact
        path="/accounting/integrations/accounting-software/connect"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftwarePage />
      </ProtectedRoute>
    </Switch>
  );
}
